import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/notifications';

class NotificationService {
  getAllNotifications = async page => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/vendor/all?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }

      const { data, message, maxReached, total, perPage } = response.data;

      return { data, message, maxReached, total, page, perPage };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching notifications.');
    }
  };

  markNotificationAsSeen = async () => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/mark-as-seen`);
      if (response.status !== 200) {
        throw new Error();
      }
    } catch (err) {
      throw handleError(err, 'Error occurred while marking notifications as seen');
    }
  };

  getNumberOfUnreadNotifications = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/unread`);
      if (response.status !== 200) {
        throw new Error();
      }
      const numberOfUnreadNotifications = response.data.data;
      return numberOfUnreadNotifications;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching number of unread notifications');
    }
  };
}
const notificationService = new NotificationService();

export default notificationService;
